import { IDashboardContext } from "../../../contexts/dashboard-context";

export function isDeleteSymbolZoneSupported(
	zone: eXpress.core.IZone | null | undefined,
	dashboard: IDashboardContext,
) {
	return !!zone && dashboard.canRemoveZone(zone);
}

export function isSymbolsPanelSupported(
	zone: eXpress.core.IZone | null | undefined,
	dashboard: IDashboardContext,
): boolean {
	return (
		!!dashboard.canReplaceSymbol(zone?.page, false) ||
		!!dashboard.canAddSymbolZone(zone?.page) ||
		!!dashboard.editor.isSymbolEditingEnabled()
	);
}
